const configElement = document.querySelector('[data-mcpetty-cart-config]');

if (configElement && !window.mcpettyCartRuntime) {
  window.mcpettyCartRuntime = (async () => {
    const config = JSON.parse(configElement.textContent);
    window.routes = { ...window.routes, ...config.routes };
    window.cartStrings = { ...window.cartStrings, ...config.cartStrings };
    window.quickOrderListStrings = { ...window.quickOrderListStrings, ...config.quickOrderListStrings };

    if (!window.StandardEvents) {
      window.StandardEvents = await import('https://cdn.shopify.com/storefront/standard-events.js');
    }

    for (const url of config.assets) {
      if ([...document.scripts].some(script => script.src === new URL(url, location.href).href)) continue;
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = resolve;
        script.onerror = reject;
        document.head.append(script);
      });
    }

    const CartItems = customElements.get('cart-items');
    if (CartItems && !CartItems.prototype.mcpettySectionMounts) {
      const getSectionsToRender = CartItems.prototype.getSectionsToRender;
      const onCartUpdate = CartItems.prototype.onCartUpdate;
      CartItems.prototype.getSectionsToRender = function () {
        return getSectionsToRender.call(this).filter(section => document.getElementById(section.id));
      };
      CartItems.prototype.onCartUpdate = function () {
        if (this.tagName !== 'CART-ITEMS') return onCartUpdate.call(this);
        const sectionId = document.getElementById('main-cart-items')?.dataset.id;
        if (!sectionId) return Promise.resolve();
        const footer = document.getElementById('main-cart-footer');
        const footerSectionId = footer?.dataset.id;
        const sectionIds = footerSectionId ? [sectionId, footerSectionId] : [sectionId];
        return Promise.all(sectionIds.map(id =>
          fetch(`${routes.cart_url}?section_id=${encodeURIComponent(id)}`).then(response => response.text())
        ))
          .then(([responseText, footerResponseText]) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const source = html.querySelector('cart-items');
            if (!source) return;
            HTMLUpdateUtility.setInnerHTML(this, source.innerHTML);
            this.classList.toggle('is-empty', source.classList.contains('is-empty'));
            if (footer && footerResponseText) {
              const footerHtml = new DOMParser().parseFromString(footerResponseText, 'text/html');
              const sourceFooter = footerHtml.getElementById('main-cart-footer');
              if (sourceFooter) {
                footer.className = sourceFooter.className;
                HTMLUpdateUtility.setInnerHTML(footer, sourceFooter.innerHTML);
              }
            }
            const count = Number(source.dataset.mcpettyItemCount);
            if (Number.isFinite(count)) {
              document.querySelectorAll('.mcpetty-header .cart-count').forEach(counter => {
                counter.textContent = count;
              });
            }
          })
          .catch(error => console.error(error));
      };
      CartItems.prototype.mcpettySectionMounts = true;
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (typeof event.cartData?.item_count !== 'number') return;
      document.querySelectorAll('.mcpetty-header .cart-count').forEach(counter => {
        counter.textContent = event.cartData.item_count;
      });
    });

    document.documentElement.classList.add('mcpetty-cart-ready');
  })().catch(() => {
    const errors = document.getElementById('cart-errors');
    if (errors) {
      const config = JSON.parse(configElement.textContent);
      errors.setAttribute('role', 'alert');
      errors.textContent = config.cartStrings.error;
    }
  });
}
